import { render, staticRenderFns } from "./editDiscount.vue?vue&type=template&id=18c7e208&scoped=true&"
import script from "./editDiscount.vue?vue&type=script&lang=js&"
export * from "./editDiscount.vue?vue&type=script&lang=js&"
import style0 from "./editDiscount.vue?vue&type=style&index=0&id=18c7e208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c7e208",
  null
  
)

component.options.__file = "editDiscount.vue"
export default component.exports